export interface NotificationTemplate {
  id: string
  templateType: string
  subject: string
  bodyText: string
  bodyHtml: string | null
  templateVariables: string | null
  isActive: boolean
  language: string | null
  description: string | null
  createdOn: string
  updatedOn: string
  updatedBy: string
}

export interface TemplateListResponse {
  templates: Array<NotificationTemplate>
  totalCount: number
}

export interface UpdateTemplateRequest {
  subject?: string
  bodyText?: string
  bodyHtml?: string
  isActive?: boolean
}

export interface PreviewTemplateRequest {
  subject?: string
  bodyText?: string
  bodyHtml?: string
  templateVariables?: string
  sampleVariablesJson?: string
}

export interface PreviewTemplateResponse {
  subject: string
  bodyText: string
  bodyHtml: string
}

export const TEMPLATE_CATEGORIES: Record<string, { label: string; types: Array<string> }> = {
  invites: {
    label: 'Invites',
    types: ['user_invite', 'invite_reminder'],
  },
  tasks: {
    label: 'Tasks',
    types: ['task_assigned', 'task_commented', 'task_status_changed', 'task_deleted', 'task_mentioned'],
  },
  reminders: {
    label: 'Reminders',
    types: ['reminder_due', 'digest_daily'],
  },
  system: {
    label: 'System',
    types: ['welcome_workspace', 'password_reset'],
  },
}

export const TEMPLATE_DISPLAY_NAMES: Record<string, string> = {
  user_invite: 'User Invitation',
  invite_reminder: 'Invite Reminder',
  task_assigned: 'Task Assigned',
  task_commented: 'Task Commented',
  task_status_changed: 'Task Status Changed',
  task_deleted: 'Task Deleted',
  task_mentioned: 'Mentioned in Task',
  reminder_due: 'Reminder Due',
  digest_daily: 'Daily Digest',
  welcome_workspace: 'Welcome to Workspace',
  password_reset: 'Password Reset',
}
